import {
    useRef
} from 'react';

import { SimpleGrid } from '@mantine/core';

import { useCustomerSubscriptions } from '../hooks/useCustomerSubscriptions.ts';
import { useCustomerSubscriptionsSelection } from '../hooks/useCustomerSubscriptionsSelection.ts';
import { useTableColumns } from '../hooks/useTableColumns.tsx';

import {
    MantineDataTable,
    TableSearchForm,
} from '@flexinet/ui-components';
import { DataTableTokenPagination } from "../../../components/DataTableTokenPagination.tsx";
import { CustomerSubscription } from '../types';

export const ReportsRecordsTable = () => {
    const { columns } = useTableColumns('reports');

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = useCustomerSubscriptions('reports');

    const { selectedRecords, setSelectedRecords } = useCustomerSubscriptionsSelection();

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword} />

            <MantineDataTable
                columns={columns}
                records={items as CustomerSubscription[]}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={setSelectedRecords}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
            />

            <DataTableTokenPagination totalCount={totalCount.toString()} nextToken={nextToken} handleLoadMore={fetchRecords} />

        </SimpleGrid>
    );
};